<emm-management-layout>
  <emm-progress-bar [isLoading$]="anyLoading$"></emm-progress-bar>
  <emm-search-filter
    [addDialog]="true"
    [attr.data-testid]="'location_set_type_select'"
    [displaySearchWithOptions]="false"
    [fields]="fields$ | async"
    [isAdminOrAuthor]="(this.isAdmin || this.isAuthor) && !isMMSAuthor"
    [isSuperAdmin]="this.isSuperAdmin"
    layout-center-header
    (add)="openCreateLocationSetDialog()"
    (filter)="onFilter($event)"
  ></emm-search-filter>
  @if (nodes$ | async) {
    <emm-generic-items-tree
      [contextMenuActions]="locationSetsContextMenuActions$ | async"
      [disableContextActions]="centerLoading$ | async"
      [disableDefaultOnMove]="true"
      [items]="nodes$ | async"
      layout-center-content
      [options]="options"
      [readonly]="(isReadOnly$ | async) || isMMSAuthor"
      [isMmsAuthorOnly]="isMMSAuthor"
    ></emm-generic-items-tree>
  }
  @if (locationSetDetail$ | async; as item) {
    <emm-management-attributes-header
      layout-right-header
      [name]="item.name"
      [tag]="item.tag"
    ></emm-management-attributes-header>
  }
  <emm-location-sets-form
    #form
    layout-right-content
    [isSuperAdmin]="isSuperAdmin"
    [isAdmin]="isAdmin"
  ></emm-location-sets-form>
  @if ((locationSetDetail$ | async) && !isMMSAuthor) {
    <emm-management-attributes-footer
      [disableCancel]="!locationSetsForm || !locationSetsForm.isFormReady()"
      [disableUpdate]="!locationSetsForm || !locationSetsForm.hasChanges()"
      layout-right-footer
      (cancel)="locationSetsForm.cancel()"
      (submit)="submitForm()"
      class="fixed-row-bottom"
    ></emm-management-attributes-footer>
  }
</emm-management-layout>
